//client/src/pages/admin/AdminContacts.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function AdminContact() {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    api.get("/admin/contact").then(res => {
      setMessages(res.data || []);
    });
  }, []);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Contact Inbox</h1>

      <div className="space-y-4">
        {messages.map(m => (
          <div
            key={m._id}
            className="card-glass p-4 space-y-1"
          >
            <div className="font-semibold">
              {m.name} <span className="text-sm text-gray-400">({m.email})</span>
            </div>
            <div className="text-sm text-gray-300">{m.message}</div>
            <div className="text-xs text-gray-500">
              {new Date(m.createdAt).toLocaleString()}
            </div>
          </div>
        ))}

        {messages.length === 0 && (
          <div className="text-gray-400 text-sm">
            No contact messages yet.
          </div>
        )}
      </div>
    </div>
  );
}
